import FJWatermarkRemoverLeft from '../view/FJWatermarkRemoverLeft';

const FJWatermarkRemoverLeftContainer = () => {

    return (
        <FJWatermarkRemoverLeft/>
    );
};

export default FJWatermarkRemoverLeftContainer; 